// controllers

import KeywordChipsRendererWithProps from "../../../pages/management/KeywordManagement/KeywordChipsRenderer";
import { SkuBrandSelectControl } from "../activityRuleSetup/Brands/brandSelect/BrandSelect";
import { BrandsPointsSelectReceiptScanControl } from "../activityRuleSetup/Brands/brandsPointsSelect/BrandsPointsSelectReceiptScan";
import { DefaultRuleSetupControl } from "../activityRuleSetup/defaultRuleSetup/DefaultRuleSetup";
import { ProductsPointsSelectControl } from "../activityRuleSetup/Products/productsPointsSelect/ProductsPointsSelect";
import { KeywordGroupsQuantitySelectorControl } from "../keywordGroupsQuantitySelector/KeywordGroupsQuantitySelector";
import { SkuProductSelectControl } from "../activityRuleSetup/Products/skuProductSelect/SkuProductSelect";
import { CheckInGeoTableController } from "../checkInGeoTable/checkInGeoTable";
import { CodeGroupSelectorControl } from "../codeGroupSelector/CodeGroupSelector";
import { DateTimePickerControl } from "../datePicker/DateTimePickerControl";
import { DatePickerMaterialUIControl } from "../datePickerMaterialUI/DatePickerMaterialUIControl";
import { DropdownSelectControl } from "../dropdownSelect/dropdownSelect";
import { ExternalSurveySelectControl } from "../externalSurveySelect/ExternalSurveySelect";
import { SingleImageUploadControl } from "../fileUpload/SingleImageUploadControl";
import { ComponentTester, ScopeTester } from "../jsonFormsWrapper/testers";
import { MatchKeywordControl } from "../matchKeywordController/MatchKeywordController";
import { MultiStepController } from "../multiStepController/MultiStepController";
import { AwardFlatPointsControl } from "../pointsOutcome/AwardFlatPoints/AwardFlatPoints";
import { AwardPurchaseBasedPointsControl } from "../pointsOutcome/AwardPurchaseBasedPoints/AwardPurchaseBasedPoints";
import { RewardAllocationConfigSelectControl } from "../rewardAllocationConfigSelect/RewardAllocationConfigSelect";
import { RichTextEditorControl } from "../richTextEditor/CustomRichTextEditorControl";
import { CampaignSegmentSelectControl } from "../segmentSelect/CampaignSegmentSelect";
import { SingleInputArrayControl } from "../singleInputFieldArray/SingleInputArrayControl";
import { StaticDropdownSelectControl } from "../staticDropdownSelect/staticDropdownSelect";
import { StringSelectControl } from "../stringSelect/StringSelect";
import { SwitchControl } from "../switchField/SwitchControl";
import { TextInputControl } from "../textInputField/TextInputControl";
import { UniqueCodeGroupSelectorControl } from "../uniqueCodeGroupSelector/UniqueCodeGroupSelector";
import { AddWinningScheduleRewardsInfoControl } from "../winningScheduleSelect/AddWinningScheduleRewardsInfo";
import { WinningScheduleSelectControl } from "../winningScheduleSelect/WinningScheduleSelect";

export const getScopesofAllElements = (schema) => {
  const listOfScopes = [];

  function traverse(obj) {
    if (!obj || typeof obj !== "object") {
      return;
    }

    if (obj.scope) {
      listOfScopes.push({
        scope: obj.scope.split("#")[1],
        component: obj.component ? obj.component : "",
      });
    }
    if (obj.elements && Array.isArray(obj.elements)) {
      obj.elements.forEach((element) => {
        traverse(element);
      });
    }
    if (obj.options?.detail && Array.isArray(obj.options?.detail?.elements)) {
      obj.options.detail.elements.forEach((element) => {
        traverse(element);
      });
    }
    // Traverse multiStepController steps
    if (obj.options?.steps && Array.isArray(obj.options?.steps)) {
      obj.options.steps.forEach((step) => {
        if (step.schema) {
          traverse(step.schema);
        }
      });
    }
  }
  traverse(schema);
  return listOfScopes;
};

export const customerRenderesHelper = (scopeAndCompsList) => {
  return scopeAndCompsList?.map(({ component, scope }) => {
    switch (component) {
      case "skuProductSelect":
        return {
          tester: ScopeTester(scope),
          renderer: SkuProductSelectControl,
        };
      case "skuBrandSelect":
        return {
          tester: ScopeTester(scope),
          renderer: SkuBrandSelectControl,
        };
      case "productsPointsSelector":
        return {
          tester: ScopeTester(scope),
          renderer: ProductsPointsSelectControl,
        };
      case "keywordGroupsQuantitySelector":
        return {
          tester: ScopeTester(scope),
          renderer: KeywordGroupsQuantitySelectorControl,
        };
      case "keywordController":
        return {
          tester: ScopeTester(scope),
          renderer: MatchKeywordControl,
        };
      case "defaultRuleSetup":
        return {
          tester: ScopeTester(scope),
          renderer: DefaultRuleSetupControl,
        };
      case "datePickerMaterialUI":
        return {
          tester: ScopeTester(scope),
          renderer: DatePickerMaterialUIControl,
        };
      case "brandsPointsSelectorReceiptScan":
        return {
          tester: ScopeTester(scope),
          renderer: BrandsPointsSelectReceiptScanControl,
        };
      case "dateTimePicker":
        return {
          tester: ScopeTester(scope),
          renderer: DateTimePickerControl,
        };
      case "stringSelect":
        return {
          tester: ScopeTester(scope),
          renderer: StringSelectControl,
        };
      case "uniqueCodeGroupSelector":
        return {
          tester: ScopeTester(scope),
          renderer: UniqueCodeGroupSelectorControl,
        };
      case "codeGroupSelector":
        return {
          tester: ScopeTester(scope),
          renderer: CodeGroupSelectorControl,
        };
      case "externalSurveySelect":
        return {
          tester: ScopeTester(scope),
          renderer: ExternalSurveySelectControl,
        };
      case "richTextEditor":
        return {
          tester: ScopeTester(scope),
          renderer: RichTextEditorControl,
        };
      case "singleImageUpload":
        return {
          tester: ScopeTester(scope),
          renderer: SingleImageUploadControl,
        };
      case "toggle":
        return {
          tester: ScopeTester(scope),
          renderer: SwitchControl,
        };
      case "checkInGeoTable":
        return {
          tester: ComponentTester("checkInGeoTable"),
          renderer: CheckInGeoTableController,
        };
      case "multiStepController":
        return {
          tester: ComponentTester("multiStepController"),
          renderer: MultiStepController,
        };
      case "KeywordChipsRenderer":
        return {
          tester: ScopeTester(scope),
          renderer: KeywordChipsRendererWithProps,
        };
      case "segmentSelect":
        return {
          tester: ScopeTester(scope),
          renderer: CampaignSegmentSelectControl,
        };
      case "textInput":
        return {
          tester: ScopeTester(scope),
          renderer: TextInputControl,
        };
      case "instantWinSelect":
        return {
          tester: ScopeTester(scope),
          renderer: WinningScheduleSelectControl,
        };
      case "addWinnningScheduleRewardsInfo":
        return {
          tester: ScopeTester(scope),
          renderer: AddWinningScheduleRewardsInfoControl,
        };
      case "RewardAllocationConfig":
        return {
          tester: ScopeTester(scope),
          renderer: RewardAllocationConfigSelectControl,
        };
      case "awardFlatPoints":
        return {
          tester: ScopeTester(scope),
          renderer: AwardFlatPointsControl,
        };
      case "awardPurchaseBasedPoints":
        return {
          tester: ScopeTester(scope),
          renderer: AwardPurchaseBasedPointsControl,
        };
      case "dropdownSelect":
        return {
          tester: ScopeTester(scope),
          renderer: DropdownSelectControl,
        };
      case "staticDropdownSelect":
        return {
          tester: ScopeTester(scope),
          renderer: StaticDropdownSelectControl,
        };
      case "singleInputArray":
        return {
          tester: ScopeTester(scope),
          renderer: SingleInputArrayControl,
        };
      default:
        return { tester: ScopeTester(scope), renderer: TextInputControl };
    }
  });
};
